import dayjs, { Dayjs } from 'dayjs';

export const getDisabledDatesBeforeToday = (currentDate: Dayjs) => {
  const today = dayjs().startOf('day');

  return currentDate.isBefore(today);
};

export const getDisabledDatesAfterToday = (currentDate: Dayjs) => {
  const today = dayjs().endOf('day');

  return currentDate.isAfter(today);
};

export const getDisabledDatesAfterTodayAndMonthBefore = (currentDate: Dayjs) => {
  const today = dayjs().endOf('day');
  const oneMonthBefore = today.subtract(30, 'day');

  return currentDate.isAfter(today) || currentDate.isBefore(oneMonthBefore);
};

export const getFormattedDate = (date?: string | Dayjs, format = 'YYYY/MM/DD hh:mm A') => (date ? dayjs(date).format(format) : '');
export const getDateForPayload = (date?: string | Dayjs | null, format = 'YYYY-MM-DDTHH:mm') => (date ? dayjs(date).format(format) : '');
